import { Badge } from "../ui/Badge";
import type { OutputGroundingSummary } from "../../../../shared/types";

interface GroundingIndicatorProps {
  grounding: OutputGroundingSummary | null | undefined;
}

function groundingCopy(grounding: OutputGroundingSummary | null | undefined): {
  badge: string;
  variant: "default" | "success" | "warning";
  body: string;
} {
  switch (grounding?.state) {
    case "grounded":
      return {
        badge: "Grounded",
        variant: "success",
        body: "Has supporting evidence.",
      };
    case "partial":
      return {
        badge: "Partial sources",
        variant: "warning",
        body: "Some supporting evidence is incomplete or missing source metadata.",
      };
    case "source_expired":
      return {
        badge: "Source expired",
        variant: "warning",
        body: "Original payload expired. Retained extracts and citations remain available.",
      };
    case "ungrounded":
      return {
        badge: "Ungrounded",
        variant: "warning",
        body: "Generated without stored supporting evidence.",
      };
    case "not_instrumented":
    default:
      return {
        badge: "Not instrumented",
        variant: "default",
        body: "Evidence capture is not enabled for this draft yet.",
      };
  }
}

export function GroundingIndicator({ grounding }: GroundingIndicatorProps) {
  const copy = groundingCopy(grounding);
  return (
    <div className="rounded-md border border-slate-200 bg-slate-50 p-3">
      <div className="flex items-center gap-2">
        <Badge variant={copy.variant}>{copy.badge}</Badge>
        <p className="text-sm font-medium text-slate-900">{copy.body}</p>
      </div>
    </div>
  );
}
